"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var icon_1 = require("../icon");
exports.default = (function (_a) {
    var children = _a.children, className = _a.className, theme = _a.theme, blue = _a.blue, orange = _a.orange, purple = _a.purple, deepPurple = _a.deepPurple, red = _a.red, green = _a.green, yellow = _a.yellow, outlineGrayFill = _a.outlineGrayFill, gray = _a.gray, gray60 = _a.gray60, outline = _a.outline, flat = _a.flat, thin = _a.thin, uppercase = _a.uppercase, small = _a.small, medium = _a.medium, large = _a.large, iconName = _a.iconName, _b = _a.iconSize, iconSize = _b === void 0 ? 1.8 : _b, _c = _a.fill, fill = _c === void 0 ? false : _c, _d = _a.type, type = _d === void 0 ? "button" : _d, others = tslib_1.__rest(_a, ["children", "className", "theme", "blue", "orange", "purple", "deepPurple", "red", "green", "yellow", "outlineGrayFill", "gray", "gray60", "outline", "flat", "thin", "uppercase", "small", "medium", "large", "iconName", "iconSize", "fill", "type"]);
    var _e;
    return (React.createElement("button", tslib_1.__assign({}, others, { type: type, className: classnames_1.default(theme.button, className, (_e = {},
            _e[theme.icon] = !!iconName,
            _e[theme.small] = small,
            _e[theme.medium] = medium,
            _e[theme.large] = large,
            _e[theme.blue] = blue,
            _e[theme.orange] = orange,
            _e[theme.purple] = purple,
            _e[theme.deepPurple] = deepPurple,
            _e[theme.red] = red,
            _e[theme.green] = green,
            _e[theme.yellow] = yellow,
            _e[theme["outline-gray-fill"]] = outlineGrayFill,
            _e[theme.gray] = gray,
            _e[theme.gray60] = gray60,
            _e[theme.flat] = flat,
            _e[theme.thin] = thin,
            _e[theme.outline] = outline,
            _e[theme.uppercase] = uppercase,
            _e[theme.fill] = fill,
            _e)) }),
        !!iconName ? typeof iconName === "string" ? React.createElement(icon_1.default, { iconName: iconName, size: iconSize }) : iconName : null,
        children));
});
